import "antd/lib/tooltip/style";
import _Tooltip from "antd/lib/tooltip";
import "antd/lib/icon/style";
import _Icon from "antd/lib/icon";
import "antd/lib/card/style";
import _Card from "antd/lib/card";
import "antd/lib/checkbox/style";
import _Checkbox from "antd/lib/checkbox";
import "antd/lib/row/style";
import _Row from "antd/lib/row";
import "antd/lib/button/style";
import _Button from "antd/lib/button";
import "antd/lib/col/style";
import _Col from "antd/lib/col";
import "antd/lib/input/style";
import _Input from "antd/lib/input";
import _objectSpread from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _classCallCheck from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _defineProperty from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "antd/lib/select/style";
import _Select from "antd/lib/select";
import "antd/lib/form/style";
import _Form from "antd/lib/form"; /*@通用页面-登录首页*/
import React from 'react';
import './IndexPage.scss';
import { withRouter } from 'react-router-dom';
import logo from '../../../assets/img/logo-index.png';
import { _crypto } from '../../../utils/commonUtilFunc';
import { domain, IconFont } from '../../../utils/commonConsts';
import localeList from "../../../locales/_localeList";
import { injectIntl } from "react-intl";
import loginbg from '../../../assets/img/loginbg.png';
import moment from "moment";
var FormItem = _Form.Item;
var Option = _Select.Option;
var IndexPage = /*#__PURE__*/function (_React$Component) {
  _inherits(IndexPage, _React$Component);
  function IndexPage(props) {
    var _this;
    _classCallCheck(this, IndexPage);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(IndexPage).call(this, props));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "get_logoPic", function () {
      _this.props.dispatch({
        type: "indexPage/get_logoPic",
        payload: {
          url: window.location.protocol + "//" + window.location.hostname,
          logo_type: 'bck'
        }
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "get_logo", function () {
      _this.props.dispatch({
        type: "indexPage/get_logo",
        payload: {
          url: window.location.protocol + "//" + window.location.hostname,
          logo_type: 'logo'
        }
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleSubmitForYanz", function (e) {
      e.preventDefault();
      var loginParam = JSON.parse(sessionStorage.getItem('loginParam'));
      _this.props.form.validateFields(function (err, values) {
        if (!err) {
          _this.props.dispatch({
            type: "indexPage/login",
            payload: _objectSpread({}, values, {
              username: loginParam.username,
              password: loginParam.password,
              allow: values.allow ? 1 : 0
            })
          }).then(function () {
            var indexPage = _this.props.indexPage;
            if (indexPage.result) {
              if (sessionStorage.getItem("role") === "company" || sessionStorage.getItem("role") === "companystaff") {
                _this.props.dispatch({
                  type: "layoutInfo/get_logo",
                  payload: {
                    company_id: sessionStorage.getItem("companyId"),
                    logo_type: 'logo'
                  }
                });
              }
              var menuInfo = indexPage.menuInfo['home'];
              var path = "";
              if (menuInfo[0].sub) {
                path = menuInfo[0].sub[0].path;
              } else {
                path = menuInfo[0].path;
              } //登陆后定位到菜单第一项为默认首页
              sessionStorage.setItem("ifLogin", true);
              _this.props.history.push("/main/" + path);
              _this.props.indexPage.result = false;
            }
          });
        }
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleSubmit", function (e) {
      e.preventDefault();
      _this.props.form.validateFields(function (err, values) {
        if (!err) {
          if (values.rememberPassword) {
            localStorage.setItem(values.userNm.replace(/(^\s*)|(\s*$)/g, ""), values.password);
          } else {
            localStorage.removeItem(values.userNm);
          }
          sessionStorage.setItem("userNm", values.userNm.replace(/(^\s*)|(\s*$)/g, ""));
          var arr = ['kai.chenit@chintanneng.com', 'zhongkui.wu@astronergy.com', 'fenglei.yuan@astronergy.com', 'ran.zhu@astronergy.com', 'zeqi.chen@astronergy.com', 'hlqi@chint.com', '97185505@qq.com', 'wjie123@chint.com', '15317709781@189.cn', 'tuyc@chint.com', 'wjie3@chint.com', 'yzhao@chint.com', '13357132260@189.com', 'wbin1@chint.com', 'jiong.zheng1@astronergy.com', 'tingbi.li@astronergy.com', 'zheng.zhao3@astronergy.com', 'zhuhr@chint.com', 'dingyu.chen@astronergy.com', 'zhongquan.sun@astronergy.com', 'qiqing.xu@astronergy.com', 'test01@lixiang.com', 'yangmk@chint.com', 'lei.li18@astronergy.com', 'yif.wang@chint.com', 'torres.wang@chint.com', 'yuxingjia@cigtech.com'];
          if (arr.indexOf(values.userNm.replace(/(^\s*)|(\s*$)/g, "")) >= 0) {
            sessionStorage.setItem("companyonlyshow", true);
          } else {
            sessionStorage.setItem("companyonlyshow", false);
          }
          _this.props.dispatch({
            type: "indexPage/login",
            payload: {
              username: values.userNm.replace(/(^\s*)|(\s*$)/g, ""),
              password: _crypto(values.password),
              captcha_code: values.captcha
            }
          }).then(function () {
            var indexPage = _this.props.indexPage;
            if (indexPage.result && !sessionStorage.getItem('access_token')) {
              var menuInfo = indexPage.menuInfo['home'];
              var path = "";
              if (menuInfo[0].sub) {
                path = menuInfo[0].sub[0].path;
              } else {
                path = menuInfo[0].path;
              } //登陆后定位到菜单第一项为默认首页
              sessionStorage.setItem("ifLogin", true);
              _this.props.history.push("/main/" + path);
              _this.props.indexPage.result = false;
              if (sessionStorage.getItem("role") === "company" || sessionStorage.getItem("role") === "companystaff") {
                _this.props.dispatch({
                  type: "layoutInfo/get_logo",
                  payload: {
                    company_id: sessionStorage.getItem("companyId"),
                    logo_type: 'logo'
                  }
                });
              }
            } else if (sessionStorage.getItem('access_token')) {
              _this.send_code();
            }
          });
        }
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "userNmOnBlur", function () {
      var userNm = _this.props.form.getFieldValue("userNm");
      userNm = userNm ? userNm.replace(/(^\s*)|(\s*$)/g, "") : "";
      var password = localStorage.getItem(userNm);
      if (password) {
        _this.props.form.setFieldsValue({
          password: localStorage.getItem(userNm),
          rememberPassword: true
        });
      }
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleForgetPassword", function () {
      _this.props.form.setFieldsValue({
        rememberPassword: false
      });
      _this.props.history.push("/rememberPwd");
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "reloadCaptcha", function () {
      _this.props.dispatch({
        type: "indexPage/reloadCaptcha",
        payload: {}
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleSelectLanguage", function (value) {
      window.location.href = domain + '/index.' + value + '.html#' + _this.props.location.pathname + _this.props.location.search;
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "count", function () {
      var yztime = _this.state.yztime;
      var siv = setInterval(function () {
        _this.setState({
          yztime: yztime--
        }, function () {
          if (yztime <= -1) {
            clearInterval(siv); //倒计时( setInterval() 函数会每秒执行一次函数)，用 clearInterval() 来停止执行:
            _this.setState({
              loading: false,
              yztime: 59
            });
            sessionStorage.setItem('errcode', '');
          }
        });
      }, 1000);
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "send_code", function (e) {
      _this.setState({
        loading: true
      });
      if (e) {
        e.preventDefault();
      }
      if (!_this.state.yztime == 0) {
        _this.count();
      }
      _this.props.dispatch({
        type: "indexPage/send_code",
        payload: {
          access_token: sessionStorage.getItem('access_token'),
          username: sessionStorage.getItem("userNm")
        }
      });
    });
    _this.state = {
      yztime: 59,
      loading: false
    };
    return _this;
  }
  _createClass(IndexPage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.get_logo();
      this.get_logoPic();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// const {indexPage} = this.props;
      // if (indexPage.result) {
      //     let menuInfo = indexPage.menuInfo['home'];
      //     let path = "";
      //     if (menuInfo[0].sub) {
      //         path = menuInfo[0].sub[0].path
      //     } else {
      //         path = menuInfo[0].path
      //     }//登陆后定位到菜单第一项为默认首页
      //     sessionStorage.setItem("ifLogin", true);
      //     this.props.history.push("/main/" + path);
      //     this.props.indexPage.result = false
      // }
    }
  }, {
    key: "render",
    value: function render() {
      var getFieldDecorator = this.props.form.getFieldDecorator;
      var inEnglish = window.appLocale.locale === "en-US";
      return /*#__PURE__*/React.createElement("div", {
        className: "loginMainContainer"
      }, 1772269695 < moment().unix() && moment().unix() < 1772402400 ? /*#__PURE__*/React.createElement("div", {
        style: {
          position: 'absolute',
          width: "50%",
          left: "25%",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
          padding: '8px',
          borderRadius: '8px',
          zIndex: '999',
          background: '#fff',
          top: '20px'
        }
      }, /*#__PURE__*/React.createElement("span", {
        style: {
          color: 'red'
        }
      }, "\u901A\u544A\uFF1A"), "\u5C0A\u656C\u7684\u5BA2\u6237\uFF0C\u672C\u516C\u53F8\u540E\u53F0\u6570\u636E\u91C7\u96C6\u7CFB\u7EDF\u5C06\u4E8E2026\u5E742\u670828\u65E518:30-3\u67082\u65E506:00\u95F4\u8FC1\u79FB\u5386\u53F2\u6570\u636E\uFF0C\u6B64\u671F\u95F4\u53EF\u80FD\u51FA\u73B0\u5386\u53F2\u66F2\u7EBF\u65AD\u70B9\u6216\u65E0\u6570\u636E\u7684\u73B0\u8C61\uFF0C\u8BF7\u77E5\u6653\uFF0C\u8FC1\u79FB\u8FC7\u7A0B\u4E0D\u5F71\u54CD\u7F51\u7EDC\u5B9E\u9645\u8FD0\u884C\uFF0C\u5982\u9700\u67E5\u770B\u5386\u53F2\u6570\u636E\u70E6\u8BF7\u7B49\u5F85\u4E0B\u5468\u4E00\uFF083\u67082\u65E5\uFF09\u8FC1\u79FB\u5B8C\u6210\u3002") : '', /*#__PURE__*/React.createElement("header", {
        className: "headerContainer"
      }, /*#__PURE__*/React.createElement("div", null, this.props.indexPage.logo_url ? /*#__PURE__*/React.createElement("img", {
        src: this.props.indexPage.logo_url === "default" ? logo : domain + this.props.indexPage.logo_url,
        alt: "",
        className: "logo",
        style: {
          marginTop: 10,
          marginLeft: 8,
          width: 118,
          height: 40
        }
      }) : "", /*#__PURE__*/React.createElement("div", {
        style: {
          display: "inline-block",
          "float": "right"
        }
      }, /*#__PURE__*/React.createElement(IconFont, {
        type: "icon-diqiu1",
        style: {
          fontSize: 24,
          marginRight: 8,
          marginTop: 20
        }
      }), /*#__PURE__*/React.createElement(_Select, {
        style: {
          width: 100,
          marginRight: 16,
          clear: 'both'
        },
        onChange: this.handleSelectLanguage,
        value: window.appLocale.locale
      }, localeList.map(function (lang) {
        return /*#__PURE__*/React.createElement(Option, {
          value: lang.name,
          key: lang.name
        }, lang.label);
      }))))), /*#__PURE__*/React.createElement("div", {
        className: "dash"
      }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "loginContainer"
      }, /*#__PURE__*/React.createElement("div", {
        className: "loginbg"
      }, this.props.indexPage.logo_pic ? /*#__PURE__*/React.createElement("img", {
        src: this.props.indexPage.logo_pic === "default" ? loginbg : domain + this.props.indexPage.logo_pic,
        alt: "loginbg"
      }) : /*#__PURE__*/React.createElement("img", {
        src: loginbg,
        alt: "loginbg"
      })), sessionStorage.getItem('access_token') || this.props.indexPage.access_token ? /*#__PURE__*/React.createElement(_Card, {
        bordered: false,
        className: "logincon"
      }, /*#__PURE__*/React.createElement("div", {
        className: "title",
        style: inEnglish ? {
          fontSize: 20
        } : {}
      }, "Enter verification code"), /*#__PURE__*/React.createElement(_Form, {
        onSubmit: this.handleSubmitForYanz
      }, /*#__PURE__*/React.createElement(FormItem, null, /*#__PURE__*/React.createElement("div", null, "The verification code has been sent to:", this.props.indexPage.telNumber ? this.props.indexPage.telNumber : sessionStorage.getItem('telNumber')), /*#__PURE__*/React.createElement("div", {
        style: {
          color: 'red',
          lineHeight: '12px'
        }
      }, sessionStorage.getItem('errcode'))), /*#__PURE__*/React.createElement(FormItem, null, /*#__PURE__*/React.createElement(_Row, null, /*#__PURE__*/React.createElement(_Col, {
        span: 12
      }, getFieldDecorator('verify_code', {
        rules: [{
          required: true,
          message: '请输入验证码!'
        }]
      })(/*#__PURE__*/React.createElement(_Input, {
        placeholder: "\u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801"
      }))), /*#__PURE__*/React.createElement(_Col, {
        span: 2
      }), /*#__PURE__*/React.createElement(_Col, {
        span: 10
      }, /*#__PURE__*/React.createElement(_Button, {
        disabled: this.state.loading,
        htmlType: "submit",
        onClick: this.send_code
      }, this.state.loading ? this.state.yztime + '秒' : '重新获取验证码'))), "\u3000\u3000\u3000\u3000\u3000\u3000 "), /*#__PURE__*/React.createElement(FormItem, null, getFieldDecorator('allow', {
        valuePropName: 'checked',
        initialValue: 0
      })(/*#__PURE__*/React.createElement(_Checkbox, null, "No verification required within seven days"))), /*#__PURE__*/React.createElement(_Button, {
        type: "primary",
        htmlType: "submit",
        className: "confirmBtn"
      }, /*#__PURE__*/React.createElement("span", {
        style: {
          color: "#fff"
        }
      }, "Sign in")))) : /*#__PURE__*/React.createElement(_Card, {
        bordered: false,
        className: "logincon"
      }, /*#__PURE__*/React.createElement("div", {
        className: "title",
        style: inEnglish ? {
          fontSize: 20
        } : {}
      }, "SD-WAN Integrated Management Platform"), /*#__PURE__*/React.createElement(_Form, {
        onSubmit: this.handleSubmit
      }, /*#__PURE__*/React.createElement(FormItem, {
        className: "FormItem"
      }, getFieldDecorator('userNm', {
        rules: [{
          required: true,
          message: "Please enter username"
        }]
      })(/*#__PURE__*/React.createElement(_Input, {
        size: "large",
        placeholder: "Please enter username",
        className: "input",
        onBlur: this.userNmOnBlur
      }))), /*#__PURE__*/React.createElement(FormItem, {
        className: "FormItem"
      }, getFieldDecorator('password', {
        rules: [{
          required: true,
          message: "Please input password"
        }]
      })(/*#__PURE__*/React.createElement(_Input, {
        size: "large",
        placeholder: "Please input password",
        className: "input",
        type: "password"
      }))), this.props.indexPage.ifCaptchaShow ? /*#__PURE__*/React.createElement(FormItem, {
        className: "FormItem"
      }, getFieldDecorator('captcha', {
        rules: [{
          required: true,
          message: "Please enter the verification code"
        }]
      })(/*#__PURE__*/React.createElement(_Input, {
        size: "large",
        style: {
          width: 120
        },
        placeholder: "Please enter the verification code",
        className: "input"
      })), /*#__PURE__*/React.createElement("img", {
        src: this.props.indexPage.captchaUrl,
        alt: "",
        style: {
          width: 100,
          height: 40,
          marginLeft: 48
        }
      }), /*#__PURE__*/React.createElement(_Icon, {
        type: "reload",
        style: {
          fontSize: 16,
          marginLeft: 8
        },
        onClick: this.reloadCaptcha
      })) : "", /*#__PURE__*/React.createElement(FormItem, null, getFieldDecorator('rememberPassword', {
        valuePropName: 'checked',
        initialValue: false
      })(/*#__PURE__*/React.createElement(_Checkbox, null, "Remember password")), /*#__PURE__*/React.createElement(_Tooltip, {
        title: "Please contact the platform administrator"
      }, /*#__PURE__*/React.createElement("span", {
        className: "common-link-icon",
        style: {
          marginLeft: inEnglish ? 5 : 140,
          color: "#1990ff"
        } // onClick={this.handleForgetPassword}
      }, "Forgot password"))), /*#__PURE__*/React.createElement(_Button, {
        type: "primary",
        htmlType: "submit",
        className: "confirmBtn"
      }, /*#__PURE__*/React.createElement("span", {
        style: {
          color: "#fff"
        }
      }, "Sign in")))))));
    }
  }]);
  return IndexPage;
}(React.Component);
export default withRouter(injectIntl(IndexPage));